import { IUISupplierWithMarker } from '@bridebook/web/lib/types';

export const isSupplierWithCoordinates = (supplier: any): supplier is IUISupplierWithMarker =>
  !!supplier.lat && !!supplier.lng;
